export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_name') || '中文名称',
    field: 'appraisalItemName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: that.$l('table_label_name_en') || '英文名称',
    field: 'appraisalItemNameEn',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: that.$l('form_label_highest_score') || '最高分值',
    field: 'appraisalItemTopScore',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('form_label_scoring_items') || '评分项填写说明',
    field: 'appraiseItemDesc',
    minWidth: 300,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_label_status') || '状态',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'itemStatus',
    },
  },
  {
    title: that.$l('table_label_sortorder') || '排序',
    field: 'sortOrder',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('form_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('form_label_modified_date') || '修改时间',
    field: 'modifyDate',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    fixed: 'right',
    align: 'center',
    width: 130,
    slots: {
      default: 'opt',
    },
  },
]
